/**
 * Scene materials reused by road meshes, procedural traffic, and environment props.
 */

import * as THREE from "three";

/**
 * @returns {Record<string, THREE.MeshStandardMaterial>} stable references for clones
 */
export function createRaceMaterials() {
  return {
    /** Single-tone playfield slab — matte to kill specular crawling at oblique camera angles. */
    deck: new THREE.MeshStandardMaterial({ color: 0x4f7562, roughness: 1, metalness: 0 }),
    road: new THREE.MeshStandardMaterial({ color: 0x333838, roughness: 0.86 }),
    shoulder: new THREE.MeshStandardMaterial({ color: 0xc5b96c, roughness: 0.9 }),
    grass: new THREE.MeshStandardMaterial({ color: 0x6b9c45, roughness: 0.92 }),
    water: new THREE.MeshStandardMaterial({ color: 0x30abc0, roughness: 0.46, metalness: 0.05 }),
    white: new THREE.MeshStandardMaterial({ color: 0xf7f3df, roughness: 0.6 }),
    yellow: new THREE.MeshStandardMaterial({ color: 0xffd54a, roughness: 0.48 }),
    /** Player rig accent trim / lights */
    accent: new THREE.MeshStandardMaterial({ color: 0xd63a2f, roughness: 0.54 }),
    blue: new THREE.MeshStandardMaterial({ color: 0x2486c7, roughness: 0.54 }),
    black: new THREE.MeshStandardMaterial({ color: 0x111111, roughness: 0.62 }),
    glass: new THREE.MeshStandardMaterial({ color: 0x0a1720, roughness: 0.25, metalness: 0.15 }),
    aiTruckMetal: new THREE.MeshStandardMaterial({ color: 0xb8b9b1, roughness: 0.72 }),
    rail: new THREE.MeshStandardMaterial({ color: 0x8a8f8e, roughness: 0.58 }),
    palm: new THREE.MeshStandardMaterial({ color: 0x2f8d43, roughness: 0.78 }),
    trunk: new THREE.MeshStandardMaterial({ color: 0x7b5434, roughness: 0.8 })
  };
}
